'use client';
import styled, { css } from 'styled-components';

export const StyledGlassCarouselArrow = styled.button`
  display: none;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 50%;
  margin: 0;
  padding: 0;
  cursor: pointer;
  background-color: #ffffff24;
  border: 1px solid #ffffff47;
  backdrop-filter: blur(24px);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.12);

  @media ${props => props.theme.tablet} {
    position: absolute;
    top: 50%;
    z-index: 20;
    display: flex;
    transform: translateY(-50%);

    ${props =>
      props.$edgePosition === 'overlap'
        ? props.$direction === 'prev'
          ? css`
              left: ${props.theme.spacing(-3)};
            `
          : css`
              right: ${props.theme.spacing(-3)};
            `
        : props.$direction === 'prev'
        ? css`
            left: 1%;
          `
        : css`
            right: 1%;
          `}
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }

  &:hover:not(:disabled),
  &:focus-visible:not(:disabled) {
    border: 1px solid ${props => props.theme.colors.border.dark};
    background-color: ${props => props.theme.colors.hero.lilac};

    svg path {
      fill: ${props => props.theme.colors.hero.plum} !important;
    }
  }

  ${props => props.theme.getFocusOutline('background.lightest')}
`;
